import { combineReducers } from '@reduxjs/toolkit';
import { reducer as storeReducer } from './slice.js';

const rootReducer = combineReducers({
  store: storeReducer,
});

export default rootReducer;
